export default function HeroSection() {
  return (
    <section className="relative pt-24 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d0b424880fc5530e0dfe38186a1e4849.jpg"
          alt="Saudi Relocation Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-[#C9A961] text-white text-sm font-semibold rounded-full mb-6">
            UK-Based Relocation Specialists
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Saudi Relocation &amp; Long-Stay Travel from UK
          </h1>
          
          <p className="text-xl text-gray-100 mb-8 leading-relaxed">
            Expert travel planning for life transitions. Flexible flights, temporary accommodation, and family relocation support for UK residents moving to Saudi Arabia.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-[#C9A961] text-white rounded-lg hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              Plan Your Relocation
            </a>
            <a
              href="tel:02034884455"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer font-semibold"
            >
              <i className="ri-phone-line"></i>
              0203 4884455
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">15+</div>
              <div className="text-sm text-gray-200">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">1000+</div>
              <div className="text-sm text-gray-200">Families Relocated</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">24/7</div>
              <div className="text-sm text-gray-200">UK Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
